// extracted by mini-css-extract-plugin
module.exports = {"sideButtonsContainer":"SideButtons_sideButtonsContainer__3Ph6o"};